import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navy text-muted" data-id="element-104" data-mp="3gfsmscqd8umz">
      <div className="h-1.5 w-full bg-gold" aria-hidden="true" data-id="element-105" data-mp="3ggtxuh7dth4p" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-106" data-mp="32onj8zjvni7d">
        <p className="text-lg font-extrabold uppercase text-white" data-id="element-107" data-mp="32m1ef7odfgsu">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-108" data-mp="36nd1b5fv1nxc">Created by mineral processing education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-gold/30 pt-6 text-xs" data-id="element-109" data-mp="38qtcrvhxfo0">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}